<template>
  <div>
    <div class="breadcrumb-container">
      <b-breadcrumb :items="breadcrumb_items"></b-breadcrumb>
    </div>
    <div id="detailscontainer">
      <div v-if="details !== ''">
        <div class="d-flex justify-content-between">
          <h2 class="mb-4 text-decoration-underline">
            Request Details (Status - {{ details.status }})
          </h2>
          <div v-if="details.status == 'Initiated'">
            <label for="">Status</label>
            <select
              name=""
              id=""
              class="custom-select"
              v-model="status"
              @change="changeStatus"
            >
              <option v-for="s in statuses" :key="s.id" :value="s.title">
                {{ s.title }}
              </option>
            </select>
          </div>
        </div>
        <div>
          <div>
            <label>
              Project Name :
              <span>{{ details.projectDetails.name }}</span>
            </label>
          </div>
          <div v-if="details.breachCoaches" class="mb-2">
            <label for="">Breach Coaches</label>
            <div class="d-flex gap-1">
              <div v-for="b in details.breachCoaches" :key="b.id" class="group">
                {{ b.name }}
              </div>
            </div>
          </div>
          <div>
            <label>
              Variant :
              <span>{{ details.variant }}</span>
            </label>
          </div>
          <div>
            <label>
              Carrier :
              <span>{{ details.carrier }}</span>
            </label>
          </div>
          <div>
            <label>
              Domain name of Client :
              <span>{{ details.clientDomainName }}</span>
            </label>
          </div>
          <div>
            <label>
              Crypto Type :
              <span>{{ details.cryptoType }}</span>
            </label>
          </div>
          <div>
            <label>
              Crypto Original Ransom Demand :
              <span>{{ details.cryptoOriginalRansomDemand }}</span>
            </label>
          </div>
          <div v-if="details.originalRansomDemand">
            <label
              >Original Ransom Demand :
              <span v-if="details.originalRansomDemand.value != null || details.originalRansomDemand.value != undefined"
                >{{ details.originalRansomDemand.value }} ({{
                  details.originalRansomDemand.currency
                }})</span
              >
            </label>
          </div>
          <div>
            <label
              >Initial Ransom Demand Screenshot :
              <span
                class="mr-2"
                v-for="file in details.initialPaymentFiles"
                :key="file.id"
              >
              
            <font-awesome-icon
                  class="fa-1x infoicon align-middle text-info"
                  :icon="['fas', 'download']"
                  @click="loadFile(details.paymentRequestId,file.id,'InitialRansomPaymentFile',false)"
                />
               
              </span>
            </label>
          </div>
          <div>
            <label
              >Crypto Negotiated Ransom Demand :
              <span>{{ details.cryptoNegotiatedRansomDemand }}</span>
            </label>
          </div>
          <div v-if="details.negotiatedRansomDemand">
            <label
              >Negotiated Ransom Demand :
              <span v-if="details.negotiatedRansomDemand.value != null || details.negotiatedRansomDemand.value != undefined "
                >{{ details.negotiatedRansomDemand.value }} ({{
                  details.negotiatedRansomDemand.currency
                }})</span
              >
            </label>
          </div>
          <div>
            <label
              >Final Ransom Demand Screenshot :
              <span
                class="mr-2"
                v-for="file in details.finalPaymentFiles"
                :key="file.id"
              >
              <font-awesome-icon
                  class="fa-1x infoicon align-middle text-info"
                  :icon="['fas', 'download']"
                  @click="loadFile(details.paymentRequestId,file.id,'FinalRansomPaymentFile',false)"
                />
              </span>
            </label>
          </div>
          <div v-if="details.currrentOfferFromArete != null">
            <label for="">Current Offer from Arete : </label>
            <span>
              {{ details.currentOfferFromArete.value }} ({{
                details.currentOfferFromArete.currency
              }})</span
            >
          </div>
          <div v-if="details.currentOfferFromTA != null">
            <label for="">Current Offer from TA : </label>
            <span>
              {{ details.currentOfferFromTA.value }} ({{
                details.currentOfferFromTA.currency
              }})</span
            >
          </div>
          <div>
            <label for=""> Negotiation Start Date and Time : </label>
            <span> {{ details.negotiationStartDateAndTime }}</span>
          </div>
          <div>
            <label for=""> Negotiation End Date and Time : </label>
            <span> {{ details.negotiationEndDateAndTime }}</span>
          </div>
          <div style="display:none">
            <label
              >Payment Requested Date :
              <span>{{ details.paymentRequestedDate | formatDate }}</span>
            </label>
          </div>
          <div>
            <label
              >Wallet Id 1:
              <span>{{ details.walletId }}</span>
            </label>
          </div>
           <div v-if="details.secondaryWalletId!='' && details.secondaryWalletId!=null">
            <label
              >Wallet Id 2:
              <span>{{ details.secondaryWalletId }}</span>
            </label>
          </div>
          <div>
            <label
              >Wallet Id 1 Screenshots :
              <span
                class="mr-2"
                v-for="file in details.walletImagesDetails"
                :key="file.id"
              >
                <font-awesome-icon
                  class="fa-1x infoicon align-middle text-info"
                  :icon="['fas', 'download']"
                  @click="loadFile(details.paymentRequestId,file.id,'WalletImage',false)"
                />
              </span>
            </label>
          </div>
          <div>
            <label
              >Wallet Id 2 Screenshots :
              <span
                class="mr-2"
                v-for="file in details.secondaryWalletImagesDetails"
                :key="file.id"
              >
                <font-awesome-icon
                  class="fa-1x infoicon align-middle text-info"
                  :icon="['fas', 'download']"
                  @click="loadFile(details.paymentRequestId,file.id,'SecondaryWalletImage',false)"
                />
              </span>
            </label>
          </div>
          <div>
            <label
              >Wallet Notes :
              <span>{{ details.walletNote }}</span>
            </label>
          </div>
          <div>
            <label
              >Copy of Ransom Note File:
              <span
                class="mr-2"
                v-for="file in details.copyOfRansomeNoteFileDetails"
                :key="file.id"
              >
                <font-awesome-icon
                  class="fa-1x infoicon align-middle text-info"
                  :icon="['fas', 'download']"
                  @click="loadFile(details.paymentRequestId,file.id,'CopyOfRansomeNoteFile',false)"
                />
              </span>
            </label>
          </div>
           <div>
            <label
              >Complete Chat History File:
              <span
                class="mr-2"
                v-for="file in details.completeChatHistoryDetails"
                :key="file.id"
              >
                  <font-awesome-icon
                  class="fa-1x infoicon align-middle text-info"
                  :icon="['fas', 'download']"
                  @click="loadFile(details.paymentRequestId,file.id,'CompleteChatHistory',false)"
                />
              </span>
            </label>
          </div>
          <div
            v-if="
              details.threatIntelDocumentDetails &&
              details.threatIntelDocumentDetails.length
            "
          >
            <label
              >Threat Intel Documents :
              <span
                class="mr-2"
                v-for="file in details.threatIntelDocumentDetails"
                :key="file.id"
              >
                <font-awesome-icon
                  class="fa-1x infoicon align-middle text-info"
                  :icon="['fas', 'download']"
                  @click="loadFile(details.paymentRequestId,file.id,'ThreatIntelDocument',false)"
                />
              </span>
            </label>
          </div>
          <div>
            <label
              >Has Proof of Life Been Completed? :
              <span>{{ details.polDetails.isCompleted ? "Yes" : "No" }}</span>
            </label>
          </div>
          <div v-if="details.polDetails.isCompleted">
            <label
              >POL File :
              <span>
                <span
                  class="mr-2"
                  v-for="file in details.polDetails.files"
                  :key="file.id"
                >
                   <font-awesome-icon
                  class="fa-1x infoicon align-middle text-info"
                  :icon="['fas', 'download']"
                  @click="loadFile(details.paymentRequestId,file.id,'POLFile',false)"
                />
                </span>
              </span>
            </label>
          </div>
          <div v-else>
            <label
              >Confirmation Communication :
              <span>{{ details.polDetails.confirmationCommunication }}</span>
            </label>
          </div>
          <div>
            <label
              >Client Physical Address :
              <span>{{ details.clientPhysicalAddress }}</span>
            </label>
          </div>
          <div style="display:none">
            <label
              >Notes about Threat Actor :
              <span>{{ details.notesAboutThreatActor }}</span>
            </label>
          </div>
          <div v-if="details.paymentDetails != null">
            <label>Payment Proof Screenshot : </label>
            <font-awesome-icon
                  class="fa-1x infoicon align-middle text-info"
                  :icon="['fas', 'download']"
                  @click="loadFile(details.paymentRequestId,file.id,'PaymentProof',false)"
                />
          </div>
          <div>
            <label
              >Ransom Payment Reason :
              <span>{{ details.ransomPaymentReason }}</span>
            </label>
          </div>
          <div>
            <label
              >Currency of the TA's Initial Demand :
              <span>{{ details.ransomDemandedIn }}</span></label
            >
          </div>
          <div>
            <label
              >Ransom Payment Mode :
              <span>{{ details.ransomPaymentMode }}</span></label
            >
          </div>
          <div>
            <label
              >Transaction Fee :
              <span>{{ details.transactionFee }} %</span></label
            >
          </div>
          <br />
          <div>
            <h5>Communication Details</h5>
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(detail, index) in details.communicationDetails"
                  :key="index"
                >
                  <td>{{ detail.type }}</td>
                  <td>{{ detail.value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div>
            <div class="mb-2" v-if="false">
              <h5>OFAC Letters</h5>
              <div class="d-flex justify-content-end">
                <button
                  class="btn btn-primary"
                  v-if="['Initiated', 'Verified'].includes(details.status)"
                  @click="generateOfacLetter(details.paymentRequestId)"
                >
                  <font-awesome-icon
                    class="fa-1x text-white mr-2"
                    :icon="['fas', 'file-word']"
                  />
                  Generate OFAC Letter
                </button>
                <button
                  class="btn btn-primary ml-2"
                  v-if="
                    details.ofacLetters &&
                    details.ofacLetters.length &&
                    ['Initiated', 'Verified'].includes(details.status) > 0
                  "
                  @click="sendApprovalEmail(details.paymentRequestId)"
                >
                  <font-awesome-icon
                    class="fa-1x text-white mr-2"
                    :icon="['fas', 'envelope']"
                  />

                  Send Approval Email
                </button>
                <button
                  class="btn btn-primary ml-2"
                  v-else-if="
                    details.ofacLetters &&
                    details.ofacLetters.length &&
                    ['Paid'].includes(details.status) > 0
                  "
                  @click="sendApprovedEmail(details.paymentRequestId)"
                >
                  <font-awesome-icon
                    class="fa-1x text-white mr-2"
                    :icon="['fas', 'envelope']"
                  />

                  Send Confirmation Email
                </button>
                <button
                  class="btn btn-primary ml-2"
                  v-if="['Invoiced'].includes(details.status) > 0"
                  @click="sendInvoiceEmail(details.paymentRequestId)"
                >
                  <font-awesome-icon
                    class="fa-1x text-white mr-2"
                    :icon="['fas', 'envelope']"
                  />

                  Send Invoice Email
                </button>
              </div>
            </div>
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Version</th>
                  <th>Created By</th>
                  <th>Created At</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(o, index) in details.ofacLetters" :key="index">
                  <td>Version - {{ index + 1 }}</td>
                  <td>{{ o.createdBy }}</td>
                  <td>{{ formatDate(o.createdAt) }}</td>
                  <td>
                    <font-awesome-icon
                      class="fa-1x infoicon align-middle text-info"
                      :icon="['fas', 'download']"
                      @click="
                        downloadOfacLetter(details.paymentRequestId, o.id)
                      "
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div>
            <div class="mb-2">
              <h5><strong>Carrier Emails</strong></h5>
            </div>
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Full Name</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="client in details.clientDetails" :key="client.email">
                  <td>{{ client.email }}</td>
                  <td>{{ client.fullName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <div class="mb-2">
              <h5><strong>Arete Emails</strong></h5>
            </div>
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Full Name</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in details.areteUserDetails" :key="user.email">
                  <td>{{ user.email }}</td>
                  <td>{{ user.fullName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <div class="mb-2">
              <h5><strong>Counsel Emails</strong></h5>
            </div>
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Full Name</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="counsel in details.counselDetails"
                  :key="counsel.email"
                >
                  <td>
                    {{ counsel.email }}
                    <template v-if="counsel.isPartner">(Partner)</template
                    ><template v-else-if="counsel.isAssociate"
                      >(Associate)</template
                    >
                  </td>
                  <td>{{ counsel.fullName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <div class="mb-2">
              <h5><strong>Client Emails</strong></h5>
            </div>
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Full Name</th>
                  <th>Is Primary</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="client in details.clientDetails" :key="client.email">
                  <td>{{ client.email }}</td>
                  <td>{{ client.fullName }}</td>
                  <td>{{ client.isPrimary ? "Yes" : "No" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ref="statusChangeModal"
      size="lg"
      centered
      scrollable
      hide-footer
      :title="`Status Change from ${details.status} to ${status}`"
      @hidden="modalHidden"
    >
      <div class="form-group">
        <label for="" class="form__label"> Comments </label>
        <textarea
          class="form-control"
          name="comments"
          id="comments"
          v-model.trim="comments"
        ></textarea>
      </div>
      <div v-if="status === 'Invoiced' && details.cryptoNegotiatedRansomDemand">
        <label for="">BTC Market Price</label>
        <input type="text" class="form-control" v-model="btc_market_price" />
      </div>
      <div v-if="showCustomFields">
        <span
          @click="showCustomFields = !showCustomFields"
          class="cfaction text-info"
          >Hide CustomFields</span
        >
        <div
          class="form-group mt-2"
          v-for="field in customfields"
          :key="field.custom_field_id"
        >
          <label for="date">{{ field.custom_field_name }}</label>
          <template v-if="field.type == 'date'">
            <date-picker
              v-model="field.display_value"
              format="DD-MMM-YYYY"
              value-type="format"
              @input="
                addUpdatedField(field.display_value, field.custom_field_id)
              "
            ></date-picker>
          </template>
          <template v-else>
            <input
              type="text"
              class="form-control"
              v-model="field.display_value"
              @blur="
                addUpdatedField(field.display_value, field.custom_field_id)
              "
            />
          </template>
        </div>
      </div>
      <div v-else>
        <template v-if="!showCustomFields">
          <span
            @click="showCustomFields = !showCustomFields"
            class="cfaction text-primary"
            >Show CustomFields</span
          >
        </template>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <button class="btn btn-primary" @click="updateStatus">
          Update Status
        </button>
      </div>
    </b-modal>
    <FilePreviewer :metaData="activeDocumentData" :filePath="inputFilePath" :isVisible="isVisiblePreview" :title="fileName" :type="mimeType" @onDownloadClick="downloadFile" ></FilePreviewer>
  </div>
</template>

<script>
import walletService from "../services/walletService.js";
import userService from"../services/userService.js";
import { EventBus } from "../EventBus";
import moment from "moment";
import { mapState } from "vuex";
import projectsService from "../services/projectService";
import DatePicker from "vue2-datepicker";
import FilePreviewer from "./common/FilePreviewer.vue"
import "vue2-datepicker/index.css";
export default {
  name: "ViewDetails",
  props: ["requestId"],
  components: { DatePicker, FilePreviewer },
  computed: {
    ...mapState({
      statuses: (state) => state.statuses,
    }),
  },
  created() {
    EventBus.$emit("toast", {
      title: "",
      message: "Fetching Wallet Request details",
      variant: "success",
    });
    Promise.all([
      walletService.getWalletRequest(this.requestId),
      walletService.getWalletStatuses(),
    ])
      .then((response) => {
        this.details = response[0].data.data;
        this.status = this.details.status;
        this.$store.commit("addWalletStatuses", response[1].data.data);
      })
      .catch((error) => {});
  },
  methods: {
    async loadFile(payementRequestid, fileId, type, isDownload) {
      let documentAccessTokenData = await userService.generateDocumentAccessToken(payementRequestid,type,fileId);
       let fileType = this.getType(documentAccessTokenData.data.fileName);
      let plainUrl = this.generateLink(
        payementRequestid,
        fileId,
        type,
        documentAccessTokenData.data.fileName,
        documentAccessTokenData.data.token
      );
      let downloadUrl = encodeURIComponent(plainUrl);
      if (isDownload) window.open(plainUrl);
      else {
        this.inputFilePath = downloadUrl;
        this.isVisiblePreview = true;
        this.mimeType = fileType;
        this.fileName =type;
        this.activeDocumentData = { payementRequestid : payementRequestid, id: fileId , fileType: type};
      }
    },
    generateLink(paymentrequestId, fileId,fileType,fileName, token) {
      return `${process.env.VUE_APP_baseUrl}document/downloadUrl?PaymentrequestId=${paymentrequestId}&FileId=${fileId}&FileName=${fileName}&FileType=${fileType}&Token=${token}`;
    },
    async downloadFile(activeFileData, name) {
      this.loadFile(activeFileData.payementRequestid, activeFileData.id, activeFileData.fileType,true);
    },
    getType(filename) {
      let extension = filename.split(".");
      let value = extension[extension.length - 1];
      return value.toUpperCase();
    },
    formatDate(date) {
      return moment(date).format("DD-MMM-YYYY LT");
    },
    downloadOfacLetter(paymentrequestId, id) {
      EventBus.$emit("toast", {
        title: "",
        message: "Downloading OFAC Letter",
        variant: "success",
      });
      walletService
        .DownloadOFACLetter(paymentrequestId, id)
        .then((response) => {
          let fileURL = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/octet-stream" })
          );
          const ofacLetter = this.details.ofacLetters.find((l) => l.id === id);
          const fileName = `${moment(ofacLetter.createdAt).format(
            "YYYY.MM.DD"
          )} OFAC Letter ${this.details.projectDetails.name}.docx`;
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          EventBus.$emit("toast", {
            title: "",
            message: "Downloaded OFAC Letter",
            variant: "success",
          });
        });
    },
    generateOfacLetter(paymentrequestId) {
      EventBus.$emit("toast", {
        title: "",
        message: "Generating OFAC Letter",
        variant: "success",
      });
      walletService.GenerateOFACLetter(paymentrequestId).then((response) => {
        EventBus.$emit("toast", {
          title: "",
          message: "Successfully generated OFAC Letter",
          variant: "success",
        });
        this.details = response.data.data;
      });
    },
    sendApprovalEmail(id) {
      EventBus.$emit("toast", {
        title: "",
        message: "Sending Approval Email",
        variant: "success",
      });
      walletService.SendApprovalEmail(id).then((response) => {
        if (response.data.data) {
          EventBus.$emit("toast", {
            title: "",
            message: "Approval Email sent Successfully",
            variant: "success",
          });
        }
      });
    },
    sendApprovedEmail(id) {
      EventBus.$emit("toast", {
        title: "",
        message: "Sending Approved Email",
        variant: "success",
      });
      walletService.SendApprovedEmail(id).then((response) => {
        if (response.data.data) {
          EventBus.$emit("toast", {
            title: "",
            message: "Approved Email sent Successfully",
            variant: "success",
          });
        }
      });
    },
    sendInvoiceEmail(id) {
      EventBus.$emit("toast", {
        title: "",
        message: "Sending Invoice Email",
        variant: "success",
      });
      walletService.SendInvoiceEmail(id).then((response) => {
        if (response.data.data) {
          EventBus.$emit("toast", {
            title: "",
            message: "Invoice Email sent Successfully",
            variant: "success",
          });
        }
      });
    },
    modalHidden() {
      this.comments = "";
      this.showCustomFields = false;
      this.status = this.details.status;
    },
    changeStatus() {
      this.$bvModal
        .msgBoxConfirm("Please confirm the status change!", {
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          okTitle: "Confirm",
          cancelTitle: "Discard",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            const that$ = this;
            projectsService
              .getProjectDetails(this.details.projectDetails.projectId, true)
              .then((response) => {
                response.data.data.custom_fields.forEach((f) => {
                  if (f.type === "date" && f.display_value !== "") {
                    f.display_value = that$.$options.filters.formatDate(
                      f.display_value
                    );
                  }
                });
                this.original_custom_fields = response.data.data.custom_fields;
                this.customfields = _.cloneDeep(
                  response.data.data.custom_fields
                );
                this.$refs["statusChangeModal"].show();
              });
          } else {
            this.status = this.details.status;
          }
        });
    },
    updateStatus() {
      const input = {
        FromStatus: this.details.status,
        ToStatus: this.status,
        Comments: this.comments,
      };
      if (this.status === "Invoiced") {
        input.AdditionalData = this.btc_market_price;
      }
      if (this.updated_custom_fields && this.updated_custom_fields.length) {
        input.CustomFields = this.updated_custom_fields;
      }
      walletService
        .UpdateWalletStatus(this.details.paymentRequestId, input)
        .then((response) => {
          this.details = response.data.data;
          this.$refs["statusChangeModal"].hide();
        });
    },
    addUpdatedField(value, id) {
      const index = this.updated_custom_fields.find(
        (f) => f.custom_field_id === id
      );
      if (index) {
        this.updated_custom_fields.splice(index, 1);
      }
      const field = this.original_custom_fields.find(
        (f) => f.custom_field_id === id
      );
      if (value === null) {
        value = "";
      }

      if (field.display_value !== value) {
        let cField = { ...field };
        cField.display_value = value;
        this.updated_custom_fields.push(cField);
      }
    },
  },
  data() {
    return {
      details: "",
      customfields: [],
      showCustomFields: false,
      payment_proof: "",
      original_custom_fields: [],
      updated_custom_fields: [],
      breadcrumb_items: [
        {
          text: "Dashboard",
          to: { name: "dashboard-view" },
        },
        {
          text: "Request Details",
          active: true,
        },
      ],
       inputFilePath:"",
       isVisiblePreview:false,
       mimeType:'',
       fileName: '',
       activeDocumentData:{},
       comments: "",
      status: "",
      btc_market_price: "",
    };
  },
};
</script>

<style lang="scss" scoped>
#detailscontainer {
  margin: 60px auto;
  width: 80%;
  span {
    color: black;
  }
}

.badge {
  color: white !important;
  padding: 5px;
  margin-left: 6px;
  font-size: 12px;
}

.badge-info {
  background-color: $primary-color;
}

.cfaction {
  cursor: pointer;
  text-decoration: underline;
  font-weight: bold;
}
</style>